var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-2/3 mb-base"},[_c('reports-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }